import { render, staticRenderFns } from "./NoInternetConnectionView.vue?vue&type=template&id=32ae6f12&"
import script from "./NoInternetConnectionView.vue?vue&type=script&lang=js&"
export * from "./NoInternetConnectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NoInternetConnectionView.vue"
export default component.exports